import * as React from "react";
import type { AppFlexMenuProps } from "./AppFlexMenu";
import { AppFlexMenu } from "./AppFlexMenu";

export const appFlexMenuRender = (props: AppFlexMenuProps): JSX.Element => (
  <AppFlexMenu {...props} />
);
